<template>
  <body class="learn-why-body">
    <div class="title">
      Why Wecobi is Superior to Traditional
      <span class="gradient-text"> Social Media Marketing </span>
    </div>
    <div class="text">
      Wecobi is transforming the marketing landscape by empowering brands to
      directly reward their customers, rather than pouring money into
      traditional social media platforms that enrich major corporations. Here’s
      how Wecobi sets itself apart:
    </div>
    <div class="text-two">Here’s how Wecobi sets itself apart:</div>
  </body>
</template>

<script>
export default {
  name: "LearnWhyTitle",
  components: {},
};
</script>

<style scoped>
.learn-why-body {
  margin-top: 75px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
}
.title {
  font-size: 40px;
  line-height: 1.2;
  font-weight: 600;
  color: #000000;
  text-align: center;
  max-width: 732px;
}
.gradient-text {
  background: linear-gradient(90deg, #eb4dbf 28%, #f98140 72%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}
.text {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  color: #000000;
  max-width: 672px;
  text-align: center;
}
.text-two {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
}

@media (max-width: 750px) {
  .learn-why-body {
    margin-top: 60px;
  }
  .title {
    font-size: 30px;
    max-width: 630px;
  }
  .text {
    max-width: 630px;
  }
}
@media (max-width: 588px) {
  .title,
  .text {
    max-width: 468px;
  }
}

@media (max-width: 431px) {
  .title {
    font-size: 30px;
  }
  .text {
    font-size: 12px;
  }
  .title,
  .text {
    max-width: 350px;
  }
}
</style>
